import { IconArrow, GlobalIcons, Box, Flex } from '@creditas-ui/react';
import { Title, Description, CardContent, Icon } from './ActiveCards.style';
import i18n from '@/i18n';
import { useWindowResize } from '@/hooks/helpers/useWindowResize';
import { Card } from '@/components/Card';
import React from 'react';

interface IconProps {
  mobile: React.ReactNode;
  desk: React.ReactNode;
}

type ActiveCardsProps = {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  icon: IconProps;
  titleKey: string;
};

const ActiveCards: React.FC<ActiveCardsProps> = ({ onClick, icon, titleKey }) => {
  const { isMobile } = useWindowResize();
  const IconComponent = isMobile ? icon?.mobile : icon?.desk;

  return (
    <Card onClick={onClick} marginBottom={{ _: '48px', '5xl': '68px' }}>
      <CardContent marginTop="0">
        <Flex alignItems="center">
          <Icon>{IconComponent}</Icon>
          <Box flex="1 1 auto">
            <Title color="neutral.90" variant={{ _: 'bodyMdMedium', '5xl': 'bodyLgMedium' }}>
              {i18n.t(`activeCardsSection:activeCards.${titleKey}`)}
            </Title>
            <Description
              color="neutral.60"
              variant={{ _: 'bodyXsRegular', '5xl': 'bodySmRegular' }}
            >
              {i18n.t('activeCardsSection:activeCards.details')}
            </Description>
          </Box>
          <GlobalIcons Icon={IconArrow} size="medium" alignSelf="flex-start" />
        </Flex>
      </CardContent>
    </Card>
  );
};

export { ActiveCards };
